import { render } from "./SponsoredContent.vue.js?vue&type=template&id=e2674220!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SponsoredContent.vue?vue&type=template&id=e2674220"
import script from "./SponsoredContent.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SponsoredContent.vue?vue&type=script&lang=js"
export * from "./SponsoredContent.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SponsoredContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/Web/scripts/pages/monetization/SponsoredContent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e2674220"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e2674220', __exports__)) {
    api.reload('e2674220', __exports__)
  }
  
  module.hot.accept("./SponsoredContent.vue.js?vue&type=template&id=e2674220!=!../../../../../node_modules/vue-loader/dist/index.js??ruleSet[0].use[0]!./SponsoredContent.vue?vue&type=template&id=e2674220", () => {
    api.rerender('e2674220', render)
  })

}


export default __exports__